'use client';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Box, Button, Container, Heading, Text } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';
import React from 'react';

import { capitalizeFirstLetter } from '@/services/string-format.service';

import Styles from './HeaderBar.module.scss';

type HeaderBarProps = {
  modelName: string;
};

const HeaderBar = ({ modelName }: HeaderBarProps) => {
  const router = useRouter();

  return (
    <Box className={Styles.headerWrapper}>
      <Container maxW={'1280'} width={'100%'}>
        <Box className={Styles.headerContainer}>
          <Box className={Styles.backBtnContainer}>
            <Button
              onClick={() => router.back()}
              className={Styles.backBtn}
              padding={0}
              role="button"
            >
              <ChevronLeftIcon role="button" />
              <Box className={Styles.backBtnText} role="button">
                Back
              </Box>
            </Button>
          </Box>
          <Box className={Styles.headingElement}>
            <Heading
              as="h1"
              className={Styles.titleLg}
              marginBottom={4}
              textAlign={'center'}
            >
              Meet the family.
            </Heading>
            <Text textAlign="center">
              Compare models across the {capitalizeFirstLetter(modelName)}{' '}
              range.
            </Text>
          </Box>
          <Box />
        </Box>
      </Container>
    </Box>
  );
};

export default HeaderBar;
